<nav class="navbar fixed-top topbar d-flex navbar-expand navbar-light navbar-bg">
    <div class="container-fluid">
        <div class="navbar-collapse collapse">
            <img alt="Logo" src="/assets/images/fastweb-logo-w-47x47.png" class="hidden-desktop ms-2 my-2">
            <ul id="usernavbar" class="navbar-nav">
                <li class="nav-item hidden-mobile">
                    <div class="d-flex align-items-start">
                        <img *ngIf="!isDefaultAvatar" [src]="userNavBar.imageUrl" width="43" height="43"
                            class="imguser rounded-circle me-2" alt="Avatar" referrerpolicy="no-referrer">
                        <div *ngIf="isDefaultAvatar" class="imguserdefault imguser rounded-circle me-2">
                            <i class="fas fa-user"></i>
                        </div>

                        <div class="flex-grow-1 userbody">
                            <strong>{{userNavBar.name}}</strong>
                            <br>
                            <span>{{userNavBar.email}}</span>
                        </div>
                    </div>
                </li>
                <li class="nav-item">
                    <button title="Logout" class="btn" (click)="logout()">
                        <i class="fas fa-sign-out-alt topbar-icon"></i>
                    </button>
                </li>
                <li class="nav-item hidden-desktop">
                    <button title="Menù" class="btn" (click)="toggleSidebar()">
                        <i class="far fa-solid fa-bars topbar-icon"></i>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</nav>